import React from 'react'
import {useDispatch} from 'react-redux'
import {useLocation} from 'react-router'
import {Link} from 'react-router-dom'
import {useMasterLayout} from 'src/app/context/MasterContext'
import useWindowDimensions from 'src/app/hooks/window-dimension.hook'
import FilterRedux from 'src/app/store/Filter/FilterRedux'
import {cn} from 'src/app/utils/cn.utils'
import {checkIsActive} from 'src/app/utils/router-helpers.utils'
import {KTSVG} from '../../Libs/Icon/KTSVG'
import BulletItem from './BulletItem'

type Props = {
  children?: React.ReactNode
  to: string
  title: string
  icon?: string
  hasBullet?: boolean
  activePath?: string
  notifity?: number
  onClick?: () => void
}

const AsideMenuItem: React.FC<Props> = ({
  children,
  to,
  title,
  icon,
  hasBullet,
  activePath,
  notifity,
  onClick,
}) => {
  const {pathname} = useLocation()
  const isActive = checkIsActive(pathname, activePath ?? to)
  const {minimize, setMinimize} = useMasterLayout()
  const dispatch = useDispatch()
  const {width} = useWindowDimensions()

  return (
    <div className='relative block p-0 text-fs-9'>
      <Link
        className={cn(
          'p-2 m-2 cursor-pointer flex flex-nowrap items-center rounded-lg transition duration-100 h-10 truncate',
          {'bg-primary-500/50 text-white': isActive},
          {'text-white': !isActive}
        )}
        to={to}
        onClick={() => {
          dispatch(FilterRedux.actions.setRemoveFilter())
          if (onClick) onClick()
          if (width < 992) setMinimize(!minimize)
        }}
      >
        {hasBullet && <BulletItem isActive={isActive} />}

        {icon && (
          <span className='flex items-center w-6 mr-3 shrink-0'>
            <KTSVG path={icon} className='w-6 h-6' />
          </span>
        )}

        <span
          className={cn('flex items-center flex-1 transition duration-300 justify-between', {
            hidden: minimize,
          })}
        >
          {title}
          {notifity ? (
            <div className='px-[10px] py-[2px] rounded-full bg-danger-600 border border-white text-white text-fs-9 font-medium'>
              {notifity}
            </div>
          ) : (
            ''
          )}
        </span>
      </Link>
      {children}
    </div>
  )
}

export default AsideMenuItem
